/**
 * (c) LBS logics
 *
 *     Mobile Business Technology GmbH
 *     4020 Linz, Austria
 *
 *     www.lbs-logics.com
 *
 *     created on 20190729 by Jan Brunner
 *     all rights reserved.
 */

import { Injectable } from '@angular/core';
import { ProcessStep } from 'src/app/_model/process-step';
import { Resetable } from '../../resetter/resetable';

@Injectable()
export abstract class ProcessStepsDaoService implements Resetable {
  public abstract saveProcessSteps(
    processSteps: ProcessStep[]
  ): Promise<void>;
  public abstract getProcessSteps(): Promise<ProcessStep[]>;
  public abstract reset(): Promise<void>;
  public abstract clear(): Promise<void>;
}
